import React, { useEffect, useState } from 'react'
import { ArrowRightCircle } from 'react-feather'

export function ContentSlider({
  children,
  className = '',
  elements = 1, // number of elements in the slider
  elementsInView = 2, // number of elements to show in the slider at once (make sure children have the correct width)
  onScroll = null,
  nextButtons = [],
  showNext = false
}) {

  let [index, setIndex] = useState(1);
  let [indexStyle, setIndexStyle] = useState('');
  let [isMobile, setIsMobile] = useState(window.innerWidth > 768 ? 0 : 1);
  // let [viewCount] = useState(Math.ceil(elements / elementsInView));
  // let [viewCount] = useState(Math.ceil(elements / elementsInView));
  let [scrollCount, setScrollCount] = useState(elements - (elementsInView - 1));
  let [scrollAmount, setScrollAmount] = useState(100 / elementsInView);

  const setScrollState = () => {
    if(window.innerWidth > 768) {
      setIsMobile(0);
      setScrollAmount(100 / elementsInView);
      setScrollCount(elements - (elementsInView - 1));
    } else {
      setIsMobile(1);
      setScrollAmount(100);
      setScrollCount(elements);
    }
  }

  window.addEventListener('resize', () => {
    setScrollState();
  });

  useEffect(() => {
    setScrollState();
  });

  function slide(override) {
    if(Number.isInteger(override)) index = override;
    if(index >= scrollCount) index = 0;
    setIndex(index + 1);
    if (isMobile) {
      setIndexStyle('translateX('+Math.floor(-index*100)+'%)');
    } else {
      setIndexStyle('translateX('+(-index*scrollAmount)+'%)');
    }

    if(typeof onScroll === 'function') {
      onScroll(index);
    }
  }

  function locator() {
    let dots = [];
    for (let i = 0; i < scrollCount; i++) {
      dots.push(
        <div key={i} className={`w-3 h-3 mr-2 cursor-pointer ${(i+1) === index ? 'bg-blue' : 'bg-gray-300'}`} onClick={() => { slide(i) }}></div>
      );
    }
    return dots;
  }

  return (
    <div className={`flex flex-col relative overflow-x-hidden ${className}`}>
      <div className={`flex flex-row justify-start relative transition-transform duration-200 pb-2`} style={{transform: indexStyle}}>
        {children}
      </div>
      <div className="relative flex flex-row justify-end py-2 pr-4 border-t border-gray-300">
        <div className={`flex flex-row py-2 ${(nextButtons.length === 0 && !showNext) ? 'border-b-4 border-black' : ''} cursor-pointer select-none`} onClick={() => { slide() }}>
          {(nextButtons.length || showNext !== false) > 0 ?
            <>
              <span className="mr-2 text-base text-blue">
                {showNext ?
                  <strong>
                  {showNext}
                  </strong>
                :
                  <strong>
                    {(index < Math.ceil(elements / elementsInView)) ? 'Next step: ' : 'Start over'}
                  </strong>
                }
                {nextButtons[index-1]}
              </span>
              <ArrowRightCircle className="hidden md:block" color="#1f4444" />
            </> :
            <>
              <span className="mr-2 text-sm font-semibold text-typo-inactive">SHOW MORE</span> <ArrowRightCircle color="#1f4444" />
            </>
          }
        </div>
        <div className="absolute flex flex-row items-center bottom-3 left-4 top-4">
          { locator() }
        </div>
      </div>
    </div>
  )
}
